import React from 'react'

import JoinWaitlist from '../../forms/JoinWaitlist';
import Button from '../../components/Button';
import GraphicTextBox from '../../components/GraphicTextBox';
import Footer from '../../components/Footer';

import './Mobile.css';


const Component = () => (
  <div className="main_mobile">

    <div className="home_sec1_m">
      <div className="home_sec1_overlay_m">
        <JoinWaitlist>
          <div className="home_sec1_textContainer">
            <div className="headerWhite_m">
              Weekly sustainable actions<br />for your community
            </div>
            <div className="bodyWhite_m">
              Baloo helps you build sustainable habits through achieving local,
              community-organized, initiatives. Join the waitlist for the winter 2020 release!
            </div>
          </div>
        </JoinWaitlist>
      </div>
    </div>


    <div className="ideas_mobile">
      <div className="blueCircle_mobile"/>
      <div className="ideasContainer_mobile">
        <img className="ideasImage_mobile"
             src="https://storage.googleapis.com/baloo-media/image/web_3/desktop/phone_islands.png"
             alt="Fog over the ocean"
        />
        <div className="ideaText_mobile">
          <GraphicTextBox color="#E2EFF3">
            <div>
              Your action for the week is:
            </div>
            <div className="ideaTextBold_mobile">
              Recycle a plastic container
            </div>
          </GraphicTextBox>
        </div>
        <div>
          <div className="headerDark_mobile">
            Get ideas for simple sustainable actions you can do
          </div>
          <div className="bodyDark_mobile">
            Baloo helps you get started by texting you a suggested action at the beginning of each week, making sustainable decisions simple.
          </div>
        </div>
      </div>
    </div>

    <div className="appMain_mobile">
      <div className="greenCircle_mobile"/>
      <div className="appContainer_mobile">
        <img className="statsImage_mobile"
             src="https://storage.googleapis.com/baloo-media/image/web_3/desktop/phone_stats.png"
             alt="Baloo statistics"
        />
        <div className="statsCopy_mobile">
          <div className="headerDark_mobile">
            Build up personal impact statistics by completing actions
          </div>
          <div className="bodyDark_mobile">
            As you complete actions, we’ll calculate the material impact for you. Over time, you’ll get a better picture of how significant your daily decisions are!
          </div>
        </div>
      </div>
      <div className="appContainerTwo_mobile">
        <img className="communityImage_mobile"
             src="https://storage.googleapis.com/baloo-media/image/web_3/desktop/phone_communities.png"
             alt="Baloo communities"
        />
        <div className="communityCopy_mobile">
          <div className="headerDark_mobile">
            Reshape your community
          </div>
          <div className="bodyDark_mobile">
            Join communities to focus your actions towards completing goals set by sustainability and community development leaders.
          </div>
        </div>
      </div>
    </div>

    <div className="globalMain_mobile">
      <div className="orangeCircle_mobile"/>
      <div className="globalContainer_mobile">
        <img className="mountainImage_mobile"
             src="https://storage.googleapis.com/baloo-media/image/web_3/desktop/phone_mountain.png"
             alt="Baloo communities"
        />
        <div className="globalText_mobile">
          <GraphicTextBox color="#F4E2CB">
            This week our community completed 1,248 actions saving 114,284 Liters of water and 923 Kilograms of CO2!
          </GraphicTextBox>
        </div>
        <div className="globalCopy_mobile">
          <div className="headerDark_mobile">
            Global updates
          </div>
          <div className="bodyDark_mobile">
            When you join Baloo, you become a part of a global sustainability community. Each week we’ll send a text to update you on the impact we made together.
          </div>
        </div>
      </div>
    </div>

    <div className="communityMain_mobile">
      <div className="communityOverlay_mobile">
        <div className="communityTitle_mobile">
          Want to build your own<br />sustainable community?
        </div>
        <div className="communitySubtext_mobile">
          Create a new Baloo Community to focus actions towards acheiving goals specific to you and your community.
        </div>
        <Button route="/contact-us">
          Get in touch
        </Button>
      </div>
    </div>

    <div className="home_nonprofitMain_m">
      <div className="home_nonprofitTitle_m">
        baloo
      </div>
      <div className="home_nonprofitSubtitle_m">
        A nonprofit technology company
      </div>
      <JoinWaitlist />
    </div>

    <Footer />
  </div>
);

Component.displayName = "Home_Mobile";

export default Component;




// WEBPACK FOOTER //
// ./src/views/Home/Mobile.js